import { Component, OnChanges } from '@angular/core';
import { filter } from 'rxjs/operators';
import { BaseComponent } from '../../shared/base-components/base.component';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerManageService } from '../shared/customer-manage.service';
import { CustomerRepresentativeContext, CustomerRepresentativeModalComponent } from './customer-representative-modal.component';
import { CustomerRepresentative } from './customer-representative.model';
import { HistoricalCustomerRepresentativeModalComponent, HistoricalRepresentativeContext } from './historical-customer-representative-modal.component';

@Component({
    selector: 'customer-representative',
    templateUrl: './customer-representative.html',
    inputs: ['customerNumber', 'representatives', 'canEdit']
})

export class CustomerRepresentativeComponent extends BaseComponent implements OnChanges {
    public representatives: CustomerRepresentative[];
    public customerNumber: number;
    public canEdit: boolean;
    public cols: any[];

    constructor(
        public modalService: MvdModalService,
        private customerService: CustomerManageService) {
        super();
        this.representatives = [];

        this.cols = [
            { field: 'firstName', header: 'Name' },
            { field: 'cellPhone', header: 'Phone' },
            { field: 'email', header: 'Email' },
            { field: 'effectiveDate', header: 'Effective Date' },
            { field: 'endDate', header: 'Expiration Date' }
        ];
    }

    ngOnInit() {
        if (this.customerNumber != null) {
            this.populateRepresentatives(this.customerNumber);
        }
    }

    ngOnChanges() {}

    populateRepresentatives(customerNumberId: number) {
        this.customerService.getCustomerRepresentatives(customerNumberId)
            .subscribe(result => {
                this.representatives = result;
            },
            e => console.log('error', e),
            () => {

            });
    }

    addRepresentative() {
        const data = new CustomerRepresentativeContext(0, this.customerNumber);
        this.modalService.open(CustomerRepresentativeModalComponent, data).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(() => this.populateRepresentatives(this.customerNumber));
    }

    editRepresentative(id) {
        const data = new CustomerRepresentativeContext(id, this.customerNumber);
        this.modalService.open(CustomerRepresentativeModalComponent, data).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(() => this.populateRepresentatives(this.customerNumber));
    }

    showHistory(id) {
        const data = new HistoricalRepresentativeContext(id);
        this.modalService.open(HistoricalCustomerRepresentativeModalComponent, data);
    }
}
